/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingContainer } from '../styles';
import {
  Main,
  OnboardingSummary,
  OnboardingWrapper,
  OnboardingElement,
  OnboardingElementTitle,
  OnboardingElementIcon,
  HomeButton,
} from './styles';
import { useReview } from '../../../contexts/review-context';
import { OnboardingReviewDetails } from './review-details';
import { Header, NavTitle } from '../header';

export const OnboardingReview: React.FC = () => {
  const { reviews = [] } = useReview();
  const navigate = useNavigate();
  const [selectedReview, setSelectedReview] = useState<any | null>(null);

  if (selectedReview) {
    return (
      <OnboardingReviewDetails review={selectedReview} onClose={() => setSelectedReview(null)} />
    );
  }

  return (
    <OnboardingContainer>
      <Header
        showBackButton={true}
        onBackNavigate={() => {
          navigate(-1);
        }}
      >
        <NavTitle>Review</NavTitle>
      </Header>
      <Main>
        <OnboardingSummary>Onboarding summary</OnboardingSummary>
        <OnboardingWrapper>
          {reviews.map((r: any) => (
            <OnboardingElement key={r.id} onClick={() => setSelectedReview(r)}>
              <OnboardingElementTitle>
                {r.title || `Question ${r.step_order}`}
              </OnboardingElementTitle>
              <OnboardingElementIcon
                src="/icons/onboarding/summary/right-arrow.svg"
                alt="Go in chat"
              />
            </OnboardingElement>
          ))}
        </OnboardingWrapper>
        <HomeButton onClick={() => navigate('/')}>Go home</HomeButton>
      </Main>
    </OnboardingContainer>
  );
};
